import { supportedLanguages } from "../../i18n";

export function i18nFields(...fieldsList: string[]) {
  const fields = fieldsList
    .map((f) => supportedLanguages.map((lang) => `${f}_${lang}`).join("\n"))
    .join("\n");

  return `
    i18n {
      ${fields}
    }
  `;
}
